import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { DOCUMENT } from '@angular/common';
import { CompanyIdService } from '../../../services/company-id.service';

@Component({
  selector: 'app-guid-missing-error',
  imports: [CommonModule],
  templateUrl: './guid-missing-error.component.html',
  styleUrls: ['./guid-missing-error.component.scss']
})
export class GuidMissingErrorComponent {
  private cachedExampleUrl: string | null = null;
  
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document,
    private companyIdService: CompanyIdService
  ) {}

  getExampleUrl(): string {
    // Cache the example URL to prevent ExpressionChangedAfterItHasBeenCheckedError
    if (this.cachedExampleUrl) {
      return this.cachedExampleUrl;
    }

    // Generate an example with a sample encoded company ID
    const sampleGuid = 'abc123-def456-ghi789';
    const encodedExample = this.companyIdService.encode(sampleGuid);
    
    if (isPlatformBrowser(this.platformId)) {
      const currentOrigin = this.document.defaultView?.location?.origin || 'http://localhost:4200';
      this.cachedExampleUrl = `${currentOrigin}/?cid=${encodedExample}`;
    } else {
      // Fallback for SSR
      this.cachedExampleUrl = `http://localhost:4200/?cid=${encodedExample}`;
    }
    
    return this.cachedExampleUrl;
  }

  reloadPage(): void {
    if (isPlatformBrowser(this.platformId) && this.document.defaultView) {
      this.document.defaultView.location.reload();
    }
  }
  
  goToHomepage(): void {
    if (isPlatformBrowser(this.platformId) && this.document.defaultView) {
      this.document.defaultView.location.href = '/';
    }
  }
} 